import React from "react";
import { IShopHistoryItem } from "@/modules/shopModule/types";
import { useTranslation } from "react-i18next";

import styles from "../ShopHistory.module.scss";

interface ShopHistoryItemProps {
  data: IShopHistoryItem;
}

const ShopHistoryItem: React.FC<ShopHistoryItemProps> = ({ data }) => {
  const { item } = data;
  const { i18n } = useTranslation();
  const lng = i18n.language;
  const itemName = item.nameTranslations[lng] || item.name;
  const categoryName = item.category.translations[lng] || item.category.name;

  return (
    <div key={item.id} className={styles.historyItem}>
      <div className="flex align-items-center justify-content-between">
        <div className={styles.itemInfo}>
          <img src={item.image} alt={itemName} className={styles.itemImage} />
          <div className={styles.itemDetails}>
            <p className={styles.itemName}>{itemName}</p>
            <p className={styles.itemCategory}>{categoryName}</p>
          </div>
        </div>
        <div className={styles.coinsContainer}>
          <span className={styles.coinsAmount}>{data?.paidAmount}</span>
          <img src={item.token.image} alt={"Token"} className={styles.tokenImg} />
        </div>
      </div>
    </div>
  );
};

export default ShopHistoryItem;
